export const CreditCard = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="20"
         height="20"
         viewBox="0 0 20 20"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M16.6665 4.16663H3.33317C2.4127 4.16663 1.6665 4.91282 1.6665 5.83329V14.1666C1.6665 15.0871 2.4127 15.8333 3.33317 15.8333H16.6665C17.587 15.8333 18.3332 15.0871 18.3332 14.1666V5.83329C18.3332 4.91282 17.587 4.16663 16.6665 4.16663Z"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M1.6665 8.33337H18.3332"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   )
}
